export default {
      id: "delete-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#delete",
      toString: function () {
        return this.url;
      }
    }